module.exports = __webpack_public_path__ + "static/media/edit-education.271ba836.png";